module.exports = __webpack_public_path__ + "static/img/13areaB_5.b727341.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/13areaB_5.png
// module id = 1121
// module chunks = 1